import * as React from 'react';

import { DomainsDescriptionsTreeConfig } from '../config';

export const DomainsDescriptionsTreeConfigContext =
  React.createContext<DomainsDescriptionsTreeConfig>(
    DomainsDescriptionsTreeConfig.DEFAULT
  );

export function useDomainsDescriptionsTreeConfig() {
  const context = React.useContext(DomainsDescriptionsTreeConfigContext);
  if (context === undefined) {
    throw new Error(
      'useDomainsDescriptionsTreeConfig must be used within a DomainsDescriptionsTreeConfigContext'
    );
  }
  return context;
}

interface DomainsDescriptionsTreeConfigContextProviderProps {
  configuration?: DomainsDescriptionsTreeConfig;
}

export function DomainsDescriptionsTreeConfigContextProvider(
  props: React.PropsWithChildren<DomainsDescriptionsTreeConfigContextProviderProps>
) {
  return (
    <DomainsDescriptionsTreeConfigContext.Provider
      value={props.configuration ?? DomainsDescriptionsTreeConfig.DEFAULT}
      {...props}
    />
  );
}
